// Cache mémoire ultra-léger, partagé entre les pages pour le rendu « local-first ».
// Quand on revient sur une section (Dashboard, Tracking, Spenders…), on réaffiche la
// DERNIÈRE donnée connue instantanément (zéro écran de chargement), puis on rafraîchit
// en arrière-plan. Vit le temps de la session (vidé au rechargement complet de la page).
const _cache = {};

export const getCached = (key) => _cache[key];
export const setCached = (key, value) => { _cache[key] = value; };
